import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Switch } from '../../primitives/Switch/Switch.js';
const STORAGE_KEY = 'artosera-fair-mode';
const LABELS = {
    fr: 'Mode foire',
    en: 'Fair mode',
};
function readStoredFairMode() {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === '1';
    }
    catch {
        return false;
    }
}
/**
 * Le mode foire et sa mémorisation (`data-layout="fair"` sur `<html>`), hors
 * de tout composant visuel : `FairModeToggle` et le menu du compte de la
 * régie s'appuient dessus.
 */
export function useFairModeChoice() {
    const [fair, setFairInterne] = useState(readStoredFairMode);
    useEffect(() => {
        if (fair) {
            document.documentElement.dataset.layout = 'fair';
        }
        else {
            delete document.documentElement.dataset.layout;
        }
    }, [fair]);
    const setFair = (checked) => {
        setFairInterne(checked);
        try {
            window.localStorage.setItem(STORAGE_KEY, checked ? '1' : '0');
        }
        catch {
            /* stockage indisponible (navigation privée) : le choix ne survit pas au rechargement */
        }
    };
    return { fair, setFair };
}
/**
 * Bascule le mode foire (2.6, D6) : thème sombre par défaut, prix en très
 * grand, cibles de 44 px, « Créer une offre » seul en accent. Ce n'est pas une
 * seconde application : une mise en page de la même régie, activée par un
 * bouton et mémorisée (`data-layout="fair"` sur `<html>`).
 */
export function FairModeToggle({ lang = 'fr', labelVisible }) {
    const { fair, setFair } = useFairModeChoice();
    return (_jsx(Switch, { label: LABELS[lang], labelVisible: labelVisible, checked: fair, onCheckedChange: setFair }));
}
//# sourceMappingURL=FairModeToggle.js.map